<template>
  <div class="imagepicker">
    <div>
      <mad-button @click="chooseFile">Choose image</mad-button>
    </div>&nbsp;
    &nbsp;
    <template v-if="value">
      <img :src="value" height="50">
    </template>
    <p v-if="uploading">Uploading</p>
    <input ref="fileinput" type="file" @input="onInput">
  </div>
</template>

<script>
import api from '../../api'

export default {
  props: {
    value: { type: String, default: null },
  },

  data: () => ({
    uploading: false,
  }),

  computed: {
    filename() {
      if (this.value) return this.value.split('//').pop()
      return null
    },
  },

  methods: {
    chooseFile() {
      this.$refs.fileinput.click()
    },

    onInput(event) {
      this.$emit('input', null)

      const file = event.target.files[0]
      api.upload(file)
        .then(({ location }) => {
          console.log('Upload result: ' + location)
          this.$emit('input', location)
        })
        .catch(error => {
          console.error(error)
          alert('There was an error uploading your photo: ', error.message)
        })
    },
  },
}
</script>

<style lang="scss">
.imagepicker {
  display: flex;
  flex-grow: 1;
  input[type="file"] {
    visibility: hidden;
    position: absolute;
    z-index: -100;
  }
}
</style>
